import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Button, Grid, Typography, WithStyles, createStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import './unRegister.css'
import MyPATDialog from '../../common/MyPATDialog';
import { MyPATLink } from '../../common';
import LoginWithOTP from './LoginWithOTP';
import { bindActionCreators } from 'redux';
import userActionsV2 from '../actions/userActionsV2';
import { singleUserAxios } from '../../../services/axios';
import { showMsg } from '../../../components/course/actions/loaderAlert';

const styles = (theme: Theme) => createStyles({
  primaryBtn:{
    backgroundColor: '#FD8619',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    padding: '12px 39px',
    marginBottom: '15px!important',
    '&:hover':{
      backgroundColor: '#FD8619',
    }
  },
  cancleBtn:{
    fontSize: 14,
    fontWeight: 600,
    color: '#FD8619',
    padding: '12px 39px',
    marginBottom: '15px!important',    
  },
});

//@ts-ignore
interface MyProps extends WithStyles<typeof styles> {
  classes: any,
  unregisteredDevicesData: any,
  loginData: any,
  location: any,
  history: any,
  setUnregisteredDevice: Function,
  showMsg:any
}

interface UnregisterDeviceState {
  showRemoveActiveDevice: boolean,
  showRemoveDevice: boolean,
  removeDeviceInfo: any,
}

class UnregisterDevice extends Component<MyProps, UnregisterDeviceState> {
  currentProps: MyProps;
  constructor(props: MyProps, state: UnregisterDeviceState) {
    super(props);
    this.currentProps = props;
    this.state = {
      showRemoveActiveDevice: false,
      showRemoveDevice: false,
      removeDeviceInfo: {},
    }
  }

  handleRemoveClick(device: any, index:number) {
    device.index = index;
    this.setState({
      showRemoveDevice: !device.isLoggedIn,
      showRemoveActiveDevice: device.isLoggedIn,
      removeDeviceInfo: device,
    })
  }

  handleModalClose() {
    this.setState({
      showRemoveActiveDevice: false,
      showRemoveDevice: false,
    })
  }

  goBackCLick() {
    this.props.setUnregisteredDevice(null);
    const userData = (this.currentProps.loginData || {}).data;
    const {username = null, type = null, countryCode = null, countryFlag = null} = userData;
    this.props.history.push({
      pathname: '/login',
      state: { 
        data: {username, type, countryCode, countryFlag}
      }
    });
  }

  updateLastActive(device: any): void {
    if (!device.lastActive) {
      device.lastActive = '';
      return;
    }
    const today: Date = new Date();
    const deviceLastActiveDate: Date = new Date(device.lastActive);
    let diffTimeInHours: number = Math.floor(
      Math.abs(today.getTime() - deviceLastActiveDate.getTime()) /
        (1000 * 60 * 60)
    );
    if (diffTimeInHours > 48) {
      device.updatedLastActive = `Last Active ${this.formatLastActiveDate(device.lastActive)}`;
      return;
    } 
    if (diffTimeInHours < 1) {
      diffTimeInHours = 1;
    }
    device.updatedLastActive = `Active ${diffTimeInHours} hour${diffTimeInHours === 1 ? '' : 's'} ago`;
  }

  formatLastActiveDate(lastActiveDate: Date): string {
    const deviceLastActiveDate: Date = new Date(lastActiveDate);
    const dayOfMonth = deviceLastActiveDate.getDate();
    let daySuffix = 'th';

    if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
      daySuffix = 'st';
    } else if (dayOfMonth === 2 || dayOfMonth === 22) {
      daySuffix = 'nd';
    } else if (dayOfMonth === 3 || dayOfMonth === 23) {
      daySuffix = 'rd';
    }
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };
    let [day, month, year] = deviceLastActiveDate
      .toLocaleDateString('en-GB', options)
      .split(' ');
    day += daySuffix;
    return `${day} ${month} ${year}`;
  }

  handleRemoveDevice() {
    const body = {
      userDeviceId : this.state.removeDeviceInfo._id,
      fingerprintId : this.state.removeDeviceInfo.device.fingerprintId,
      appName: 'authors',
      removeDeviceInfo: this.state.removeDeviceInfo,
    };
    singleUserAxios.patch('v4/user-devices', body).then((res: any) => {
      if (res && res.code === 200) {
        this.props.history.push({ data: { 
          ...this.props.location.data,
          showUnregisterDeviceOtp: true,
          userDataPass: res.data,
          deviceInfo: body
        } });
      } else {
        this.props.showMsg(res.message, 'error');
      }
    }).catch((err) => {
      this.props.showMsg(err.message, 'error');
    })
  }

  browserMap: any = {
    'Safari': 'safari',
    'Mobile Safari': 'safari',
    'Chrome': 'chrome',
    'Edge': 'edge',
    'Firefox': 'firefox',
    'android': 'android',
    'fallback': 'generic-browser',
  }
  getBrowserImage(browser: any, deviceName: any){
    const android = this.browserMap['android'];
    if(deviceName.toLowerCase().includes(android)){
      return android;
    }
    return this.browserMap[browser] || this.browserMap['fallback'];
  }

  render() {

    const { classes, unregisteredDevicesData } = this.props;
    ((unregisteredDevicesData || {}).registeredDeviceList || []).forEach((device: any) => {
      device.browserImg = `/assets/img/manage-device/${this.getBrowserImage(device.device.model, device.device.name)}.svg`;
      this.updateLastActive(device);
    })
    const deviceType = {
      DESKTOP: 'desktop'
    };
    const DEVICE_NAME_MAX_SIZE = 23;
    return (
      <div className="login-container">
        <em></em><em></em><em></em><em></em>
        <div className="sign-in-container w600">
          <div className="current-reg-device">
              <div className="goBack">
                <div onClick={()=>{this.goBackCLick()}}>
                  <span className="arrow">
                    <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 12L12 24.0015L14.1195 21.879L5.742 13.5H24V10.5H5.742L14.1195 2.121L12 0L0 12Z" fill="#333333" />
                    </svg>
                  </span> Back To Login
                </div>
              </div>
              <div className="infoImg">
                <img src="/assets/img/manage-device/unregistered.svg" alt="unregistered"/>
                {/* <img src="/assets/img/manage-device/unregistered-desktop.svg" alt="unregistered"/>
                <img src="/assets/img/manage-device/unregistered-mob.svg" alt="unregistered"/> */}
              </div>
              <div className="unreg-device">
                <div className="content">
                  <h5>Unregistered Device</h5>
                  <p>You can sign in to Glorifire Authors Platform with your registered device only.<br/>
                    In order to add your new device having <b>{unregisteredDevicesData && (unregisteredDevicesData.newDevice || {}).model}</b>, please remove existing device having <b>{unregisteredDevicesData && (unregisteredDevicesData.currentDevice || {}).model}</b> and then try to log in. You can login through only <b>One Registered Laptop/Desktop</b> <br/>
                    Please check your registered device list below.</p>
                </div>
              </div>
              <div className="regDevice-contaier">
              <h4>Current Registered Devices</h4>
              <div className="regDevice-panel">
                {
                  unregisteredDevicesData && (unregisteredDevicesData.registeredDeviceList || []).map((deviceInfo: any, index: number)=> (
                    <div className="device-card" key={index}>
                      <div>
                        <div className="devicetype left">
                            <div className="registerDeviceImg">
                                <img src={`/assets/img/manage-device/${deviceInfo.device.type === 'desktop' ? 'desk' : 'mob'}-device.svg`} alt="Registered Device"/>
                                <div>
                                    <div className="deviceName">{(deviceInfo.device || {}).model}  </div>
                                    <p>{(deviceInfo.device || {}).location}</p>
                                </div>
                            </div>
                        </div>
                        <div className="devicetype left">
                          <img className="browser-logo" src={deviceInfo.browserImg} alt="browser"/>
                          <div>
                            <div className="deviceName" title={deviceInfo.device.name}>{deviceInfo.device.name.slice(0,DEVICE_NAME_MAX_SIZE)}{deviceInfo.device.name.length > DEVICE_NAME_MAX_SIZE ? '...' : ''}</div>
                            {
                              deviceInfo.isLoggedIn ? 
                              <div className="active"><img src="/assets/img/manage-device/active-dot.svg" alt="Active"/> Active</div>
                              :
                              <p>{deviceInfo.updatedLastActive}</p>
                            }
                          </div>
                        </div>
                      </div>
                      <a role="button" className="deviceStatus" onClick={() => {this.handleRemoveClick(deviceInfo, index)}} >Remove</a>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <MyPATDialog
        dialogOpen={this.state.showRemoveDevice}
        dialogHasActions={true}
        dialogHeading={false}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false}
        isborderDialogAction={true}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: "sm",
        }}
        customDialogActions={
          <>
            <div className={classes.txtRight}>
              <Button className={classes.cancleBtn} onClick={()=>{this.handleModalClose()}}>
                No
              </Button>
              <Button className={classes.primaryBtn} onClick={()=>{this.handleRemoveDevice()}}>
                Yes
              </Button>
            </div>
          </>
        }
      >
        <Grid
          container
          direction="row"
          justify="center"
        >
          <div className="dialogBody">
            <img src="/assets/img/manage-device/reg-device.svg" alt="Remove Device" />
            <h4 className="heading">Remove Device</h4>
            <p className="deviceInfo">Are you sure you want to remove <b>{unregisteredDevicesData && (unregisteredDevicesData.currentDevice || {}).model}</b> as your registered device?</p>
          </div>
          
        </Grid>
      </MyPATDialog>
      <MyPATDialog
        dialogOpen={this.state.showRemoveActiveDevice}
        dialogHasActions={true}
        dialogHeading={false}
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false}
        isborderDialogAction={true}
        otherDialogProps={{
          fullWidth: false,
          maxWidth: "sm",
        }}
        customDialogActions={
          <>
            <div className={classes.txtRight}>
              <Button className={classes.cancleBtn} onClick={()=>{this.handleModalClose()}}>
                No
              </Button>
              <Button className={classes.primaryBtn} onClick={()=>{this.handleRemoveDevice()}}>
                Yes
              </Button>
            </div>
          </>
        }
      >
        <Grid
          container
          direction="row"
          justify="center"
        >
          <div className="dialogBody">
            <img src="/assets/img/manage-device/activeDevice.svg" alt="Remove Device" />
            <h4 className="heading">Remove Active Device</h4>
            <p className="deviceInfo">You are already active on your registered device having <b>{unregisteredDevicesData && (unregisteredDevicesData.currentDevice || {}).model}</b>. At any given time, you can access Glorifire Authors Platform through only one of your registered devices.</p>
            <div className="info">
              Continuing further will automatically log you out and remove this device from your registered device list.
            </div>
            <p className="deviceInfo"> Are you sure you want to continue?</p>
          </div>
          
        </Grid>
      </MyPATDialog>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  unregisteredDevicesData: state.loginData.userData.unregisteredDevicesData,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setUnregisteredDevice: userActionsV2.setUnregisteredDevice,
  showMsg
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(withRouter(UnregisterDevice)));
